import { Component, EventEmitter, Input, OnInit,Output,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppComponent } from 'src/app/app.component';
import { CommonService } from 'src/app/services/common.service';
import { CreatepinService } from '../setuppin.service';
// import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
// import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
// import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { Global } from 'src/app/global';
import { ToastrService } from 'ngx-toastr';

const moment = _rollupMoment || _moment;
// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'MM/YYYY',
//   },
//   display: {
//     dateInput: 'MM/YYYY',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };

@Component({
  selector: 'app-setuppin',
  templateUrl: './setuppin.component.html',
  styleUrls: ['./setuppin.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    // {
    //   provide: DateAdapter,
    //   useClass: MomentDateAdapter,
    //   deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    // },

    // { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class SetuppinComponent implements OnInit {
  dobValidationError: boolean;
@ViewChild('ngCard') ngCardRef: any;
@ViewChild('ngCard2') ngCardRef2: any;
inputConfig = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: true,
    disableAutoFocus: true,
    placeholder: '',
    inputStyles: {
      'width': '60px',
      'height': '60px',
      'font-size':'14px'
    }
  };

  inputConfig2 = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: true,
    disableAutoFocus: true,
    placeholder: '',
    inputStyles: {
      'width': '60px',
      'height': '60px',
      'font-size':'14px'
    }
  };

  constructor(
    public appComp: AppComponent,
    public commonServices: CommonService,
    private router: Router,
    public createpinService: CreatepinService,
    private ngxService: NgxUiLoaderService,
    public global: Global,
    private toastr: ToastrService,

  ) { }

  ngOnInit(): void {    
    // this.clickTrack('openPinSetup','load')
  }

  ngAfterViewInit(){
    var inputElements = document.getElementsByClassName("otp-input")
      for(var i=0;i<inputElements.length;i++){
        inputElements[i].setAttribute("inputmode","numeric");
      }
    }

  public todayDate = moment(new Date()).format('YYYY-MM-DD');
  public maxDOBDate = moment(this.todayDate).add(10, 'years').format('YYYY-MM-DD');
  public createPin: string;
  public reCreatePin:string;
  public pinAlert: boolean = false;
  private pinCreated : boolean = false
  // public date: any = moment(new Date()).format('MM/YY');
  public date: string = null;
  // inputConfig1 = {
  //   "length": 4, "allowNumbersOnly": true, "isPasswordInput": true, "disableAutoFocus": true
  // }
  // inputConfig2 = {
  //   "length": 4, "allowNumbersOnly": true, "isPasswordInput": true, "disableAutoFocus": true
  // }

  requestPinSetup(data) {
    if(this.pinCreated){
    }
    else{
      this.pinCreated = true
      this.ngxService.start()
      this.clickTrack('requestTokenForPinSetup', 'submit')
      let expDate = moment(data.expiryDate, 'MM/YY').format('MMYYYY')
      if(this.createPin == this.reCreatePin){
        this.commonServices.getApiToken("PINCARDCHANGE").subscribe(
          res => {
            // this.ngxService.stop()
            this.pinCreated = false
            if (res && res['id']) {
              this.clickTrack('requestTokenForPinSetup_Success', 'apiCall')
              this.submitLoginPin(expDate, data.cvvNo, res['id'])
            }
            else{
              this.toastr.error("Something went wrong, please try again later!")
              this.clickTrack('requestTokenForPinSetup_Success_noDataFound', 'apiCall')
            }
          },
          err => {
            this.ngxService.stop()
            this.pinCreated = false
            if(err && err.error.cause && err.error.cause.includes('No CRD session found')){
              this.commonServices.logoutUser()
            }
            else{
              this.toastr.error("Something went wrong, please try again later!")
            }
          }
        )
      }else{
        this.pinAlert = true;
      }
    }
  }

  submitLoginPin(date, cvvNo, tokenid) {
    this.ngxService.start()
    this.clickTrack('createdPin', 'submit')
    this.createpinService.postCreatedPin(cvvNo, this.createPin, this.reCreatePin, date, tokenid).subscribe(
      res => {
        this.ngxService.stop()
        this.clickTrack('createdPin_Success', 'apiCall')
        if(res && res['rewardResponse']){
          this.commonServices.userInfo['rewardResponse'] = res['rewardResponse']
        }
        this.appComp.crossSellData = res;
        this.appComp.openSetupSucessful('pinSetup',res?.['showSucessPage'] ? true : false)
        // if(sessionStorage.getItem("utm_source")){
        //   this.global.successScreenRef['type'] = 'pinSetup'
        //   this.global.successScreenRef['activateFlag'] = res?.['showSucessPage'] ? true : false
        //   sessionStorage.setItem("successScreen","successScreen")
        //   this.router.navigate(['/successScreen'])
        // }
        // else{
        //   this.appComp.openSetupSucessful('pinSetup',res?.['showSucessPage'] ? true : false)
        // }
        // res['addOnUrl'] = null;
        // res['splitUrl'] = null;
        // console.log("data",res) 
      }, 
      err => {
        this.ngxService.stop()
        this.clickTrack('createdPin_Failure', 'apiCall')
        this.toastr.error("Something went wrong, please try again later!")
      }
    )
  }

  public otpChangeInput(pin, type) {
    if (type == 'pin') {
      this.createPin = pin;
    }
    else {
      this.reCreatePin = pin;
    }
    if (this.createPin && this.reCreatePin && this.createPin.length == 4 && this.reCreatePin.length == 4 && this.createPin != this.reCreatePin) {
      this.pinAlert = true;
    }
    else {
      this.pinAlert = false;
    }
  }


  skipRedirect() {
    this.commonServices.postManageData("ALREADY_SET_PIN" , "skip")
    this.router.navigate(['/dashboard'])
  }

  clickTrack(label, action) {
    this.commonServices.trackUser(label, action, null)
  }

  changeInputConfig(value,type) {
    if(type == 'confirmPin'){
      this.inputConfig2['isPasswordInput'] = (value == 'show' ? false : true)
    }else{
      this.inputConfig['isPasswordInput'] = (value == 'show' ? false : true)
    }

  }

  private checkMonth(arg, low, high, target?) {
    if (arg >= low && arg <= high) {
      if (target) {
        arg = target
      }
    } else {
      arg = ''
    }

    if (arg == '' && target) {
      let val = target.split('/')
      arg = val[0] + '/'
    }

    return arg
  }

  private checkForYear(arg, target?) {
    let low = this.minMaxObj['year'].min
    let high = this.minMaxObj['year'].max

    low = low.charAt(0)
    high = high.charAt(0)

    if (arg >= low && arg <= high) {
      if (target) {
        arg = target
      }
    } else {
      arg = ''
    }

    return arg
  }


  public minMaxObj = {
    month: {
      min: 1,
      max: 12,
    },
    year: {
      min: '01',
      max: '99'
    }
  }

  public doFormat(target) {

    // validation for date
    if (target.length == 2) {
      const low = this.minMaxObj['month'].min;
      const high = this.minMaxObj['month'].max;
      this.date = this.checkMonth(target, low, high)
    }

    // validation for / after date
    if (target.length == 3) {
      let val = target.split('/')
      this.checkForSlash(val, 1, target)
    }

    if (target.length == 4) {
      let val = target.split('/')
      this.checkForYear(val[1], target)
    }

    // validation for month
    if (target.length == 5) {
      let val = target.split('/')
      const low = this.minMaxObj['year'].min;
      const high = this.minMaxObj['year'].max;
      this.date = this.checkMonth(val[1], low, high, target)
    }

    if (this.date && target && (target.length == 2)) {
      this.date = this.date + '/'
    }

    setTimeout(() => {
      if (this.date == '' || this.date == '/') {
        this.date = ''
      }
    });

  }

  private checkForSlash(val, max, target) {
    if (val.length == max) {
      let last = target.charAt((target.length - 1));
      if (last != '/') {
        this.date = this.date.slice(0, -1) + '/' + last
      }
    }
  }




}
